module.exports = __webpack_public_path__ + "media/images/icons/icon_round_one_blue-cd4f619d8dc5c33eeeb70a1dff8c7c07.svg";